import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  TenderingBandwidthArrayModel,
  TenderingBandwidthModel,
} from "../../models/TenderingBandwidthModel";

const initialTenderingBandwidthState: TenderingBandwidthArrayModel = {
  all_TenderingBandwidths: [],
  particular_TenderingBandwidth: {
    tenderingBandwidthId: 0,
    name: "",
    description: "",
    isActive: true,
  },
  isTenderBandwidthsFetching: false,
};
const TenderingBandwidthSlice = createSlice({
  name: "ProjectTenderingBandwidth",
  initialState: initialTenderingBandwidthState,
  reducers: {
    setTenderingBandwidth(
      state,
      action: PayloadAction<TenderingBandwidthModel[]>
    ) {
      state.all_TenderingBandwidths = action.payload;
    },
    setParticularTenderingBandwidth(
      state,
      action: PayloadAction<TenderingBandwidthModel>
    ) {
      state.particular_TenderingBandwidth = action.payload;
    },
    setIsTenderBandwidthsFetching(state, action: PayloadAction<boolean>) {
      state.isTenderBandwidthsFetching = action.payload;
    },
  },
});
export default TenderingBandwidthSlice;
